let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bSvNH")).then(() => parcelRequire('l70w0'));